/**
 * Categorias padrão para o módulo Prosperidade (Orçamento Pessoal).
 * type: 'income' | 'expense'
 * icon: emoji string ou 'TRENDING_UP' / 'TRENDING_DOWN' para ícones MUI
 */
export const DEFAULT_PROSPERITY_CATEGORIES = [
  // Receitas (outros no final)
  { id: 'salario', label: 'Salário', icon: '💰', type: 'income' },
  { id: 'outros-receita', label: 'Outros (receita)', icon: 'TRENDING_UP', type: 'income' },

  // Despesas (outros no final)
  { id: 'casa', label: 'Casa', icon: '🏠', type: 'expense' },
  { id: 'lazer', label: 'Lazer', icon: '🍕', type: 'expense' },
  { id: 'transporte', label: 'Transporte', icon: '🚗', type: 'expense' },
  { id: 'compras', label: 'Compras', icon: '🛒', type: 'expense' },
  { id: 'saude', label: 'Saúde', icon: '🩺', type: 'expense' },
  { id: 'investimentos', label: 'Investimentos', icon: '📈', type: 'expense' },
  { id: 'educacao', label: 'Educação', icon: '🎓', type: 'expense' },
  { id: 'assinaturas', label: 'Assinaturas', icon: '🧾', type: 'expense' },
  { id: 'doacoes', label: 'Doações', icon: '🤝', type: 'expense' },
  { id: 'fatura-cartao', label: 'Fatura cartão', icon: '💳', type: 'expense' },
  { id: 'outros-despesa', label: 'Outros (despesa)', icon: 'TRENDING_DOWN', type: 'expense' },
];
